import http from "../../utils/http";

export const getRegions = () => {
  return new Promise((resolve, reject) => {
    http.get(`/region`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCitys = (regionCode) =>
  new Promise((resolve, reject) => {
    http.get(`/region/${regionCode}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
